import BufferTabView from 'buffers/BufferTabView';

// Used for both proteins and sequences - Model should typically conform to PolymerMapTabState<Sequence | Protein>
// but it's not a strict requirement.
abstract class PolymerBufferTabView<M extends Backbone.Model> extends BufferTabView<M> {
  abstract addPolymersForSearch(): void;
  abstract removePolymersForSearch(): void;

  override remove(): this {
    super.remove();
    this.removePolymersForSearch();
    return this;
  }

  override render(): this {
    super.render();
    this.addPolymersForSearch();
    return this;
  }
}

export default PolymerBufferTabView;
